import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./AboutContent.css";
import FontSpirulina from '../../font_component/spirulina_font/FontSpirulina';

const AboutContent = () => {
  return (
    <div className="container">
    <Container className="about-content">
      <Row className="align-items-center">
        {/* Left */}
        <Col md={6}>
          <h2 className="section-title">About <span><FontSpirulina  color="#3C9734" weight="normal" >Our Community</FontSpirulina></span></h2>
          <h5 className="section-subtitle">
            A Trusted Platform with 5-Level Growth Opportunities
          </h5>
          <p className="section-text">
            We are building a transparent and community-driven platform where
            trusted users grow together through referrals, wellness products,
            and multi-level earning opportunities.
          </p>

          <Row className="mt-4">
            <Col sm={6}>
              <Card className="feature-card">
                <img src="/images/about/Group 39580.png" className="iconImage" alt="icon" />
                <h5>01 Wellness Product</h5>
                <p>Supporting energy, immunity & nutrition</p>
              </Card>
            </Col>

            <Col sm={6}>
              <Card className="feature-card">
                <img src="/images/about/Group 39579.png" className="iconImage" alt="icon" />
                <h5>Strong User Community</h5>
                <p>Built on trust and shared growth</p>
              </Card>
            </Col>
          </Row>
        </Col>

        {/* Right*/}
        <Col md={6} className="right-content">

          <div className="stats-wrapper">
            <div className="stats-grid">
              <div className="stat-box top-left">
                <div className="hover-box"></div>
                <h3>25k+</h3>
                <p>Growing trust across the community</p>
              </div>

              <div className="stat-box top-right">
                 <div className="hover-box"></div>
                <h3>5 <span className="small-text">Levels</span></h3>
                <p>Referral Growth Opportunities</p>
              </div>

              <div className="stat-box bottom-left">
                 <div className="hover-box"></div>
                <h3>1L+</h3>
                <p>Successful Community Transactions</p>
              </div>

              <div className="stat-box bottom-right">
                 <div className="hover-box"></div>
                <h3>100%</h3>
                <p>Natural Formula Made from clean, nutrient-rich</p>
              </div>

              {/* Center Circle */}
              <div className="center-icon">
                <img src="/images/about/ScrollGroup2.png" alt="center icon" />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      
    </Container>
    </div>
  );
};

export default AboutContent;
